export default __webpack_public_path__ + "static/media/bg-image.07b85533.png";